import React from 'react';
import './style.scss';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../Shared/components/controls/Button';
import clsx from 'clsx';

const LogoListingHeader = ({
  title,
  description,
  total,
  totalLabel,
  renderButton,
  onClick,
  mode = 'static',
}) => (
  <div className={clsx('logo-listing-header', mode === 'modal' && 'logo-listing-header-modal')}>
    <div className="ll-header-title-wrapper">
      <h2 className="ll-header-title">
        <Text field={title} />
      </h2>
      <RichText className="ll-header-description" field={description} />
    </div>
    {renderButton && mode === 'static' && (
      <Button variant="text" arrow="right" onClick={onClick}>
        <span>
          Show all {total} <Text field={totalLabel} />
        </span>
      </Button>
    )}
    {mode === 'modal' && (
      <button onClick={onClick}>
        <CloseButton />
      </button>
    )}
  </div>
);

const CloseButton = () => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.9987 0.255249C7.7937 0.255249 0.332031 7.71692 0.332031 16.9219C0.332031 26.1269 7.7937 33.5886 16.9987 33.5886C26.2037 33.5886 33.6654 26.1269 33.6654 16.9219C33.6654 7.71692 26.2037 0.255249 16.9987 0.255249ZM16.9987 3.58858C24.362 3.58858 30.332 9.55858 30.332 16.9219C30.332 24.2852 24.362 30.2553 16.9987 30.2553C9.63536 30.2553 3.66536 24.2852 3.66536 16.9219C3.66536 9.55858 9.63536 3.58858 16.9987 3.58858ZM11.9987 10.2552C11.572 10.2552 11.127 10.3986 10.8004 10.7236C10.1504 11.3753 10.1504 12.4686 10.8004 13.1202L14.602 16.9219L10.8004 20.7236C10.1504 21.3753 10.1504 22.4686 10.8004 23.1202C11.452 23.7702 12.5454 23.7702 13.197 23.1202L16.9987 19.3186L20.8004 23.1202C21.452 23.7702 22.5454 23.7702 23.197 23.1202C23.847 22.4686 23.847 21.3753 23.197 20.7236L19.3954 16.9219L23.197 13.1202C23.847 12.4686 23.847 11.3753 23.197 10.7236C22.8704 10.3986 22.4254 10.2552 21.9987 10.2552C21.572 10.2552 21.127 10.3986 20.8004 10.7236L16.9987 14.5252L13.197 10.7236C12.8704 10.3986 12.4254 10.2552 11.9987 10.2552Z"
      fill="white"
    />
  </svg>
);

export default LogoListingHeader;
